import axios from 'axios';
import config from '@/config';

export default {
    namespaced: true,
    state: {
        cms_client_config: {}
    },
    getters: {
        GET_CMS_CLIENT_CONFIG: (state) => state.cms_client_config
    },
    mutations: {
        SET_CMS_CLIENT_CONFIG(state, config) {
            state.cms_client_config = { ...config }
        }
    },
    actions: {
        async GET_CMS_CLIENT_CONFIG({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(config.server_url + '/api/settings/cms-client-config')
                    .then(response => {
                        commit('SET_CMS_CLIENT_CONFIG', JSON.parse(response.data.config));
                        resolve({ success: response.data.success, config: JSON.parse(response.data.config) });
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },

        async UPLOAD_LOGO({ commit }, payload) {
            try {
                const formData = new FormData();
                formData.append("login_logo", payload.file);
                formData.append("cms_client_config", JSON.stringify(payload.config));

                const response = await axios({
                    method: 'POST',
                    url: config.server_url + '/api/settings/uploadLogo',
                    data: formData,
                    config: { headers: { 'Content-Type': 'multipart/form-data' } },
                });

                if (response.data.success) {
                    commit('SET_CMS_CLIENT_CONFIG', response.data.config);
                } else {
                    throw message;
                }
            } catch (err) {
                throw err;
            }
        },

        async UPLOAD_SIGNAGE_BACKGROUND({ commit }, payload) {
          try {
              const formData = new FormData();
              formData.append("signage_background", payload.file);

              const response = await axios({
                  method: 'POST',
                  url: config.server_url + '/api/settings/uploadSignageBackground',
                  data: formData,
                  config: { headers: { 'Content-Type': 'multipart/form-data' } },
              });

              if (response.data.success) {
                  console.log('response: ', response.data);
              } else {
                  throw 'An error occurred while uploading signage background';
              }
          } catch (err) {
              throw err;
          }
      },

      async UPLOAD_SIGNAGE_LOGO({ commit }, payload) {
        try {
            const formData = new FormData();
            formData.append("signage_logo", payload.file);

            const response = await axios({
                method: 'POST',
                url: config.server_url + '/api/settings/uploadSignageLogo',
                data: formData,
                config: { headers: { 'Content-Type': 'multipart/form-data' } },
            });

            if (response.data.success) {
                console.log('response: ', response.data);
            } else {
                throw 'An error occurred while uploading signage logo';
            }
        } catch (err) {
            throw err;
        }
    },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js